import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { LegendColor } from '@/components/kol/detail/engagement-analyses/common/styled'

interface CustomApexChartTooltipProps {
  title: {
    dateRange: string
    postCount: string
    hint: string
  }
  content: {
    extraInfo: {
      name: string
      value: string
    }
    seriesData: {
      name: string
      value: string
      color: string
    }[]
  }
}

const CustomApexChartTooltip: FunctionComponent<
  CustomApexChartTooltipProps
> = ({ title, content }) => {
  return (
    <Wrapper>
      <Head>
        <DateRangePostCount>
          {title.dateRange} ( {title.postCount} )
        </DateRangePostCount>
        <Hint>{title.hint}</Hint>
      </Head>
      <Content>
        <CustomInfo>
          {content.extraInfo.name}: {content.extraInfo.value}
        </CustomInfo>
        <SeriesWrapper>
          {content.seriesData.map((data) => (
            <LegendWrapper key={data.name}>
              <LegendColor color={data.color} />
              <span>{data.name}:</span>
              <LegendValue> {data.value}</LegendValue>
            </LegendWrapper>
          ))}
        </SeriesWrapper>
      </Content>
    </Wrapper>
  )
}

export default CustomApexChartTooltip

const Hint = styled.div`
  text-wrap: wrap;
`

const DateRangePostCount = styled.div`
  font-weight: 500;
`

const Head = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  font-size: 11px;
  color: #595959;
  background: #f0eded;
  padding: 8px;
`

const LegendValue = styled.div`
  font-weight: 700;
`

const LegendWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  font-size: 12px;
`

const CustomInfo = styled(LegendWrapper)`
  font-weight: 700;
  color: black;
`

const SeriesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #595959;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 11px;
  padding: 8px;
`

const Wrapper = styled.div`
  border-radius: 4px;
  width: 200px;
  display: flex;
  flex-direction: column;
`
